import React from 'react';
import Tooltip from 'components/customDesign/Tooltip';
import { Profile } from 'types/User';
import { InformationCircleIcon } from '@heroicons/react/24/solid';
import { Typography } from '@mui/material';
import { AdminDesc, MemberDesc } from './RolesDescription';

const TooltipText: React.FC = () => {
  return (
    <div className="space-y-2">
      <MemberDesc />
      <AdminDesc />
    </div>
  );
};

export const MembershipText: React.FC<{ profile?: Profile }> = ({ profile }) => {
  if (!profile) return null;
  return (
    <div>
      <Typography className="font-bold text-gray-500 flex items-center gap-1">
        {profile.is_admin ? 'Admin' : 'Team Member'}
        <Tooltip tooltipText={<TooltipText />}>
          <InformationCircleIcon className="h-5" />
        </Tooltip>
      </Typography>
    </div>
  );
};
MembershipText.displayName = 'Settings.Profile.MembershipText';
